import { $, html, View } from 'rune-ts';
import klass from '@services/MarppleShop/renderApp/pages/Main/views/DomainBanner/DomainBanner.module.scss';
import { staticFont } from '@services/MarppleShop/shared/typography';

interface DomainBannerPaginationData {
  current_index: number;
  max_index: number;
}

export class DomainBannerPaginationView extends View<DomainBannerPaginationData> {
  protected override template() {
    const pagination = this.data;

    return html`
      <div class="pagination ${klass.pagination} ${staticFont('bebas_16_bold', 'bebas_14_bold')}">
        <span class="current_index"> ${this.calcIndex(pagination.current_index)} </span>
        <div class="${klass.pages}">
          <div class="progress ${klass.page}" style="width: ${this.calcProgress()}%;"></div>
        </div>
        <span> ${this.calcIndex(pagination.max_index)} </span>
      </div>
    `;
  }

  calcIndex(index: number) {
    return `${index + 1 < 10 ? '0' : ''}${index + 1}`;
  }

  calcProgress() {
    const pagination = this.data;

    return ((pagination.current_index + 1) / (pagination.max_index + 1)) * 100;
  }

  setCurrentIndex(index: number) {
    this.data.current_index = index;
  }

  override redraw(): this {
    const pagination = this.data;
    $(this.element()).find('.current_index')?.setInnerHtml(this.calcIndex(pagination.current_index));
    const progress = $(this.element()).find('.progress')?.element();
    if (progress) {
      progress.style.width = `${this.calcProgress()}%`;
    }
    return this;
  }
}
